import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col pt-20 p-10 items-center text-white z-20" }
const _hoisted_2 = { class: "font-normal text-2xl" }
const _hoisted_3 = { class: "font-bold text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.subTitle), 1)
  ]))
}